var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "20px",
    viewBox: "0 -960 960 960",
    width: "20px",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187-144q-20 4-33.5-10t-9.5-34l37-178 184 185-178 37Zm178-37L181-366l430-429q21-21 50.5-21t50.5 21l83 82q21 21 21 51t-21 51L365-181Zm296-563L271-353l82 82 391-390-83-83Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon3);
export default __webpack_public_path__ + "static/media/pencil_icon3.540efb59cb4f7002ad87696edc345106.svg";
export { ForwardRef as ReactComponent };